import { Radio } from 'antd';
import classNames from 'classnames';
import React from 'react';
import InputTitle from '../inputTitle';
import type { IProps } from './types';
import styles from './style.module.scss';

/**
 * Group of radio options with a title and configurable layout. Renders InputTitle above an Ant Design Radio.Group fed from props.options with its option type, size and selected value, applies the vertical class when the direction is vertical, and reports changes as a name and value pair.
 *
 * @param props - Option list and selected value, title and required flag, option type, size and direction, class names, disabled flag and change handler.
 * @returns The rendered radio group element.
 */
const RadioGroup = (props: IProps): React.JSX.Element => {
  const { optionType = 'default', size = 'large', direction = 'horizontal', name = '' } = props;

  /**
   * Reports the newly picked radio option to the form owner. Optionally calls props.onChange with the group name and the event target's value.
   *
   * @param e - The radio change event.
   * @returns Nothing.
   */
  const onChange = (e: any) => {
    props.onChange?.(name, e.target.value);
  };

  return (
    <div className={classNames(styles.radioGroupWrapper, 'radio-group-wrapper', props.className)}>
      <InputTitle title={props.title} isRequired={props.isRequired} />
      <Radio.Group
        name={props.name}
        className={classNames(
          styles.radioGroup,
          direction === 'vertical'
            ? classNames(styles.radioGroupVertical, 'radio-group-vertical')
            : '',
          props.innerClassName,
        )}
        options={props.options}
        optionType={optionType}
        size={size}
        value={props.value}
        onChange={onChange}
        disabled={props.disabled}
      />
    </div>
  );
};

export default RadioGroup;
